export type TimeWindowReason = 'too_early' | 'closed';

export interface TimeWindowStatus {
  allowed: boolean;
  reason?: TimeWindowReason;
  message: string;
}

export function getTimeWindowStatus(appointmentDateTime: string): TimeWindowStatus {
  const apptTime = new Date(appointmentDateTime).getTime();
  const now = Date.now();
  const minsUntil = (apptTime - now) / 60000;
  const minsSince = (now - apptTime) / 60000;

  if (minsUntil > 15) {
    const waitMins = Math.ceil(minsUntil - 15);
    return {
      allowed: false,
      reason: 'too_early',
      message: `Your appointment hasn\u2019t started yet. You can join up to 15 minutes before your scheduled time. Please come back in ${waitMins} minute${waitMins !== 1 ? 's' : ''}.`,
    };
  }
  if (minsSince > 60) {
    return {
      allowed: false,
      reason: 'closed',
      message:
        'This appointment\u2019s join window has closed. Please contact us if you need to reschedule.',
    };
  }
  return { allowed: true, message: '' };
}
